import React from 'react';
import { Dialog, IconButton, Box } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark } from '@fortawesome/free-solid-svg-icons';
import { RecruiterDashboard } from './index';
import type { RecruiterDashboardProps } from './index';

interface ApplicantReviewModalProps extends RecruiterDashboardProps {
  open: boolean;
  onClose: () => void;
}

export const ApplicantReviewModal: React.FC<ApplicantReviewModalProps> = ({ open, onClose, applicantStatus, offerId }) => {
  return (
    <Dialog open={open} onClose={onClose} fullScreen PaperProps={{ sx: { backgroundColor: '#0B0C0E' } }}>
      <Box sx={{ position: 'absolute', top: 12, right: 12, zIndex: 1300 }}>
        <IconButton
          onClick={onClose}
          size="small"
          sx={{ color: '#fff', backgroundColor: 'rgba(255,255,255,0.08)', '&:hover': { backgroundColor: 'rgba(255,255,255,0.16)' } }}
        >
          <FontAwesomeIcon icon={faXmark} />
        </IconButton>
      </Box>
      <RecruiterDashboard applicantStatus={applicantStatus} offerId={offerId} />
    </Dialog>
  );
};

export default ApplicantReviewModal;
